import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppCoreService } from 'src/app/services/app-core.service';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/edit-delete.component';
import { ColumnApi, GridApi, GridReadyEvent, GridOptions } from 'ag-grid-community';
import { PickupService } from 'src/app/services/operations/pickup.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TransferPickupsComponent } from '../pickup-transfer/transfer.component';
import { BulkAssignPickupsComponent } from '../pickup-bulk-assign/bulk-assign.component';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-listpickup',
  templateUrl: './listpickup.component.html',
  styleUrls: ['./listpickup.component.scss']
})
export class ListPickupComponent implements OnInit {
  pickupList = [];
  isDisabled = true;

  isActionAllowed = true;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  public isCollapsed = true;

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    sortable: true,
    resizable: false,

  };

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: "autoHeight",
    rowSelection: 'multiple',
    suppressRowClickSelection: true,
    // getRowId: (data: any) => data.id, // Ensure unique row identification
    isRowSelectable: (rowNode: any) => rowNode.data.status !== 'Assigned', // Disable selection for 'Assigned' status
  }

  columnDefs = [
    { headerName: 'Pickup No.', field: 'pickupno', filter: true, minWidth: 140, checkboxSelection: true, headerCheckboxSelection: true },
    {
      headerName: 'Pickup Date',
      field: 'pickupdate',
      maxWidth: 150,
      filter: 'agDateColumnFilter',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        if (!valueA || !valueB) return 0; // Handle empty values

        const [dayA, monthA, yearA] = valueA.split('-').map(Number);
        const [dayB, monthB, yearB] = valueB.split('-').map(Number);

        return new Date(yearA, monthA - 1, dayA).getTime() - new Date(yearB, monthB - 1, dayB).getTime();
      },
      filterParams: {
        comparator: (filterDate: Date, cellValue: string) => {
          if (!cellValue) return 0;

          const [day, month, year] = cellValue.split('-').map(Number);
          const cellDate = new Date(year, month - 1, day).setHours(0, 0, 0, 0); // Normalize to start of day
          const filterTime = filterDate.setHours(0, 0, 0, 0); // Normalize to start of day

          if (cellDate < filterTime) return 1;
          if (cellDate > filterTime) return -1;
          return 0;
        },
        browserDatePicker: true,
        defaultOption: 'inRange',
        suppressAndOrCondition: true,
        suppressFilterButton: false,
        buttons: ['reset'],
        inRangeInclusive: true,
      }
    },
    { headerName: 'Pickup From', field: 'shippername', filter: true },
    { headerName: 'Contact Person', field: 'contactperson' },
    { headerName: 'Executive Name', field: 'fieldexecutive' },
    {
      headerName: 'Status',
      field: 'status',
      cellRenderer: (params: { value: string; }) => {
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;
        if (params.value === 'BOOKING_INFO_RECEIVED') {
          statusHtml = `<span class="badge bg-light">PICKUP CREATED</span>`;
        } else if (params.value === 'Assigned') {
          statusHtml = `<span class="badge bg-warning">${params.value}</span>`;
        } else if (params.value === 'Confirm') {
          statusHtml = `<span class="badge bg-success">${params.value}</span>`;
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      field: 'id',
      // cellRendererParams: { context: this },
      cellRenderer: EditDeleteActionsRenderer,
      colId: 'params',
      editable: false,
      sortable: false,
      minWidth: 150,
    },
  ];
  rowData = [];

  constructor(
    public router: Router,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private pickupService: PickupService,
    private modalService: NgbModal,
    private titleService: Title
  ) {
    titleService.setTitle('Pickup');
    this.context = { componentParent: this };
  }

  ngOnInit() {
    this.checkPermission();
    if (this.permConfig.isViewAllowed) {
      this.bindPickupList();
    }
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'Pickups');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindPickupList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.pickupService.GetAllList({ refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          // console.log('res from list pickup',res);
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.errorDialog('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/operation/pickups/edit', cell.id]);
      }

    } catch (e) {
      console.error(e);
    }

  }

  deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.errorDialog('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      this.openConfirmationDialog('Are you sure you want to delete ?', cell.id);
    }

  }

  deleteRecord(id) {
    try {
      this.ngxLoaderService.start();
      if (id) {
        this.pickupService.Delete(id).subscribe((res) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            this.bindPickupList(true);
            this.appCoreService.showMessage('Record deleted successfuly', 'Success', 'success');
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
            this.appCoreService.showMessage(res?.message, 'Error', 'error');
          }
        });
      }
    } catch (e) {
      this.ngxLoaderService.stop();
      console.error(e);
    }
  }

  onRowSelected() {
    let req = this.gridOptions?.api?.getSelectedRows();
    req.length > 0 ? this.isDisabled = false : this.isDisabled = true
  }

  openTransfer() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(TransferPickupsComponent, ngbModalOptions);
    modalRef.result.then(
      (onfulfilled) => {
        this.bindPickupList(true);
        // console.log('Closed with: result', onfulfilled);
      },
      (rejectReason) => {
        // if (rejectReason === 'Pickup transferred failed') {
        //   this.appCoreService.showMessage(rejectReason, 'Warning', 'warning');
        //   // console.log('Dismissed reason', rejectReason);
        // }
      }
    );
  }

  openAssign() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'sm',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    let selectedRows = this.gridOptions?.api?.getSelectedRows();
    selectedRows = selectedRows.filter(x => x.status === 'BOOKING_INFO_RECEIVED' || x.status === 'Confirm');
    const modalRef = this.modalService.open(BulkAssignPickupsComponent, ngbModalOptions);
    modalRef.componentInstance.selectedRows = selectedRows;
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
          this.bindPickupList(true);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason !== 'Cross click') {
          setTimeout(() => this.bindPickupList(true), 500);
        }
      }
    );
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // titleText: 'Confirmation',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      // call delete api
      this.deleteRecord(id);

    }

  }

  async errorDialog(msg: any) {
    await Swal.fire({
      // title: 'Error!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  formateDate(datetime: any): string {
    try {
      const timestamp = new Date(datetime);
      const year = timestamp.getFullYear();
      const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
      const day = timestamp.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error('Error occurred during date parsing:', error);
      return '';
    }
  }
}
